import { Checkbox, CheckboxChangeEvent } from 'antd'
import { FC, useContext } from 'react'
import CalculationPosition from '../../../../../../types/api/calculation-position'
import { CalculationPageCtx } from '../../../../calculations-page'

interface ShipmentTypeCheckboxProps {
    checked?: boolean
    record: CalculationPosition
}

const ShipmentTypeCheckbox: FC<ShipmentTypeCheckboxProps> = ({ checked, record }) => {
    const { onUpdateCalculationPositionProperty } = useContext(CalculationPageCtx)

    const handleChange = (e: CheckboxChangeEvent) => {
        if (e.target.checked) {
            onUpdateCalculationPositionProperty(record, ['shipmentType', 'colorProof'])
            return
        }

        onUpdateCalculationPositionProperty(record, {
            list: [
                ['shipmentType', 'label'],
                ['sellingPrice', null],
            ],
        })
    }

    return <Checkbox checked={!!checked} onChange={handleChange} />
}

export default ShipmentTypeCheckbox
